import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { DeploymentSwitchService } from '../../services/deployment/deployment-switch.service';

/**
 * Shown instead of the app shell when this host serves the `next` frontend and the user lacks
 * `read:next-ui`. Deliberately chrome-less — no toolbar, sidebar or router outlet.
 */
@Component({
  selector: 'semeris-next-unavailable',
  templateUrl: './next-unavailable.component.html',
  host: { class: 'flex flex-1 min-h-screen' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NextUnavailableComponent {
  private readonly deploymentSwitch = inject(DeploymentSwitchService);

  /** The classic frontend at the same path — the only way out of this screen. */
  public classicUrl(): string | null {
    return this.deploymentSwitch.peerUrl();
  }
}
